$(function() {
	// スクロールしたら、画像をふわっと出す
	$(window).on('scroll', function() {
		$('.anime').each(function() {
			const elemPos = $(this).offset().top + 200;
			const scroll = $(window).scrollTop();
			const windowHeight = $(window).height();
			if (scroll >= elemPos - windowHeight) {
				$(this).addClass('is-fade-up');
			}
		});
	})
});